import { $t } from "helpers/translator"

const ConnectYourFirstPlatform = {
    steps: [
        {
            target: '#clinicNumber',
            title: $t('global.tours.ConnectYourFirstPlatform.0.title'),
            content: $t('global.tours.ConnectYourFirstPlatform.0.content'),
            locale: {
                next: $t('global.tours.ConnectYourFirstPlatform.0.confirm'),
            }
        },
        {
            target: '#clinicNumber',
            title: $t('global.tours.ConnectYourFirstPlatform.1.title'),
            content: $t('global.tours.ConnectYourFirstPlatform.1.content'),
            locale: {
                last: $t('global.tours.ConnectYourFirstPlatform.1.confirm')
            }
        }
    ],
    url: '/account'
}

export default ConnectYourFirstPlatform